import { render, staticRenderFns } from "./historialLiquidacion.vue?vue&type=template&id=042b4f44"
import script from "./historialLiquidacion.vue?vue&type=script&lang=js"
export * from "./historialLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports